<template>
  <div class="location-breadcrumb">
    <h5 class="section-title">📁 Ubicación de Guardado</h5>
    <b-card class="location-card">
      <div class="breadcrumb-path">
        <span
          v-for="(item, index) in location.breadcrumb"
          :key="index"
          class="breadcrumb-item"
        >
          {{ item }}
          <span v-if="index < location.breadcrumb.length - 1" class="separator">
            <feather-icon icon="ChevronRightIcon" size="14" />
          </span>
        </span>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'LocationBreadcrumb',
  props: {
    location: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.location-breadcrumb {
  margin-bottom: 1.5rem;
  
  .section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 1rem;
  }
  
  .location-card {
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    
    .breadcrumb-path {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem;
      font-size: 1rem;
      
      .breadcrumb-item {
        display: inline-flex;
        align-items: center;
        color: #2c3e50;
        font-weight: 500;
        
        &:last-child {
          color: #7367f0;
          font-weight: 600;
        }
        
        .separator {
          display: inline-flex;
          align-items: center;
          margin-left: 0.5rem;
          color: #6c757d;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .location-breadcrumb {
    .location-card {
      .breadcrumb-path {
        font-size: 0.9rem;
        
        .breadcrumb-item {
          .separator {
            margin-left: 0.25rem;
          }
        }
      }
    }
  }
}
</style>
